import { toast as shadcnToast } from '../components/ui/use-toast';

export const useToast = () => {
  return {
    toast: ({ title, description, variant = 'default' }: { 
      title: string; 
      description?: string; 
      variant?: 'default' | 'destructive';
    }) => {
      shadcnToast({
        title,
        description,
        variant
      });
    }
  };
};